module.exports = __webpack_public_path__ + "static/media/edward_chu.60b26810.png";